import React, { useState } from 'react';
import { motion } from 'framer-motion';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const MaintenanceLogModal = ({ isOpen, onClose, onSave, printer }) => {
  const [form, setForm] = useState({
    amount: '',
    daysDown: '',
    reason: '',
    date: ''
  });

  const formatCurrencyMask = (val) => {
    const digits = String(val || '')?.replace(/\D/g, '');
    const num = Number(digits) / 100;
    return num.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  };

  const handleChange = (field, value) => {
    if (field === 'amount') {
      setForm(prev => ({ ...prev, amount: formatCurrencyMask(value) }));
      return;
    }
    setForm(prev => ({ ...prev, [field]: value }));
  };

  const handleSubmit = (e) => {
    e?.preventDefault?.();
    const amountRaw = Number(String(form.amount).replace(/\D/g, '')) / 100;
    onSave?.({
      amount: amountRaw,
      daysDown: Number(form.daysDown || 0),
      reason: form.reason || '',
      date: form.date || new Date().toISOString().slice(0,10)
    }, printer);
    onClose?.();
  };

  if (!isOpen) return null;

  return (
    <>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50"
        onClick={onClose}
      />
      <motion.div
        initial={{ y: '100%' }}
        animate={{ y: 0 }}
        exit={{ y: '100%' }}
        transition={{ type: 'tween', duration: 0.2 }}
        className="fixed bottom-0 left-0 right-0 bg-background border-t border-border z-50 p-6 rounded-t-2xl"
      >
        <div className="flex items-center justify-between mb-4">
          <div>
            <h3 className="text-lg font-semibold text-foreground">Registrar Manutenção</h3>
            <p className="text-sm text-muted-foreground">{printer?.name || printer?.model}</p>
          </div>
          <Button variant="ghost" size="icon" iconName="X" onClick={onClose} />
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <Input
            label="Valor da manutenção"
            type="text"
            placeholder="R$ 0,00"
            value={form.amount}
            onChange={(e) => handleChange('amount', e?.target?.value)}
          />
          <Input
            label="Dias parado"
            type="number"
            placeholder="0"
            value={form.daysDown}
            onChange={(e) => handleChange('daysDown', e?.target?.value)}
          />
          <Input
            label="Motivo"
            type="text"
            placeholder="Ex: Troca de bico, lubrificação, correia"
            value={form.reason}
            onChange={(e) => handleChange('reason', e?.target?.value)}
          />
          <Input
            label="Data"
            type="date"
            value={form.date}
            onChange={(e) => handleChange('date', e?.target?.value)}
          />

          <div className="flex items-center gap-3 pt-2">
            <Button variant="outline" type="button" onClick={onClose} className="flex-1">Cancelar</Button>
            <Button variant="primary" type="submit" iconName="Save" iconPosition="left" className="flex-1">Salvar</Button>
          </div>
        </form>
      </motion.div>
    </>
  );
};

export default MaintenanceLogModal;